<section *ngIf="contentResults.length">
    <h3 class="display-label">
        {{ headline }}
    </h3>
    <ul class="result-text">
        <li class="list-item" *ngFor="let result of contentResults">
            <a #link class="action kk-overflow-ellipsis kk-hover-underline" appSetIsFocused [routerLink]="result.url">
                {{ result.title }}
            </a>
            <span class="display-label content-type" *ngIf="showType">{{
                'search.contentTypes.' + result.contentType | translate
            }}</span>
        </li>
    </ul>
</section>
